import defaultPlatformThumbnail from '@assets/social-media/platform-thumbnails/default_platform.svg';
import { Avatar, Box, Typography } from '@mui/material';
import { platformMapper, SocialMediaPlatform } from '@services/types/api';
import React from 'react';

interface Props {
  platform: SocialMediaPlatform;
}

export const getPlatformIconPath = async (platform: SocialMediaPlatform): Promise<string> => {
  try {
    const icon = await import(
      `@assets/social-media/platform-thumbnails/${platform}.${
        platform === SocialMediaPlatform.INSTAGRAM_ADS ? 'png' : 'svg'
      }`
    );
    return icon.default;
  } catch (error) {
    console.warn(`Icon for platform "${platform}" not found.`);
    const fallbackIcon = await import(
      '@assets/social-media/platform-thumbnails/default_platform.svg'
    );
    return fallbackIcon.default;
  }
};

const PlatformInfo = ({ platform }: Props) => {
  const [icon, setIcon] = React.useState<string>();

  React.useEffect(() => {
    getPlatformIconPath(platform).then((icon) => setIcon(icon));
  }, [platform]);

  return (
    <Box display="flex" alignItems="center" width="100%" gap="5px">
      <Avatar
        alt="platform"
        sx={{ width: 12.3, height: 12.3 }}
        src={icon || defaultPlatformThumbnail}
      ></Avatar>

      <Box className="ellipsis">
        <Typography variant="body2" className="ellipsis" sx={{ fontSize: '9px' }}>
          {platformMapper[platform]}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(PlatformInfo);
